import { getCurrentInstance } from "vue";

import type { ComponentInternalInstance } from "vue";
import type { GlobalProperties } from "@/util/tips.ts";

export function useCurrentInstance() {
  const { appContext } = getCurrentInstance() as ComponentInternalInstance;
  // app.use(TDesign) 注入的全局方法（$message 等）按项目实际用法收窄
  const globalProperties = appContext.config.globalProperties as unknown as GlobalProperties;
  return {
    globalProperties,
  };
}

export function debounce(fn: (...args: unknown[]) => void, delay = 300) {
  let timer: ReturnType<typeof setTimeout> | null;

  return function (...args: unknown[]) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
}

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
